import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const columns = [
    {
      title: 'Company',
      links: [
        { label: 'About', to: '/about' },
        { label: 'Careers', to: '/about' },
        { label: 'Blog', to: '/about' },
        { label: 'Contact', to: '/contact' },
      ],
    },
    {
      title: 'Products',
      links: [
        { label: 'Services', to: '/services' },
        { label: 'Pricing', to: '/pricing' },
        { label: 'Changelog', to: '/announcement' },
        { label: 'Roadmap', to: '/announcement' },
      ],
    },
    {
      title: 'Resources',
      links: [
        { label: 'Documentation', to: '/services' },
        { label: 'API Reference', to: '/services' },
        { label: 'Status', to: '/services' },
        { label: 'Community', to: '/contact' },
      ],
    },
    {
      title: 'Legal',
      links: [
        { label: 'Privacy Policy', to: '/about' },
        { label: 'Terms of Service', to: '/about' },
        { label: 'Cookie Policy', to: '/about' },
        { label: 'Security', to: '/about' },
      ],
    },
  ];

  return (
    <footer className="bg-dark border-t border-white/5 pt-20 pb-10 font-display">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 lg:grid-cols-5 gap-10 mb-16">
          {/* Brand column */}
          <div className="col-span-2 lg:col-span-1">
            <Link to="/" className="flex items-center gap-3 mb-5">
              <div className="w-8 h-8 text-primary">
                <svg fill="none" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="24" cy="24" r="20" stroke="currentColor" strokeDasharray="10 4" strokeWidth="4" />
                  <circle cx="24" cy="24" fill="currentColor" r="8" />
                  <path d="M40 24C40 32.8366 32.8366 40 24 40" stroke="currentColor" strokeLinecap="round" strokeWidth="2" />
                </svg>
              </div>
              <span className="text-xl font-bold text-white">OrbitMind</span>
            </Link>
            <p className="text-gray-500 text-sm leading-relaxed mb-6">
              The AI operating system for modern enterprises. Automate, orchestrate, and grow.
            </p>
            <div className="flex gap-3">
              {['twitter', 'linkedin', 'github'].map((platform) => (
                <a
                  key={platform}
                  href="#"
                  aria-label={platform}
                  className="w-9 h-9 rounded-lg bg-white/5 border border-white/10 flex items-center justify-center hover:bg-primary/10 hover:border-primary/30 transition-colors"
                >
                  <span className="material-symbols-outlined text-gray-400 text-base">link</span>
                </a>
              ))}
            </div>
          </div>

          {/* Link columns */}
          {columns.map((col) => (
            <div key={col.title}>
              <h4 className="text-white font-bold text-sm uppercase tracking-widest mb-5">{col.title}</h4>
              <ul className="space-y-3">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <Link to={link.to} className="text-gray-500 text-sm hover:text-white transition-colors">
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom bar */}
        <div className="border-t border-white/5 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-gray-600 text-sm">
            © {new Date().getFullYear()} OrbitMind, Inc. All rights reserved.
          </p>
          <div className="flex items-center gap-2">
            <span className="w-2 h-2 rounded-full bg-emerald-400 animate-pulse" />
            <span className="text-gray-600 text-sm">All systems operational</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
